// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Speisekarte von {{platform}} importieren',
    copy: 'Speisekarte von {{restaurant}} kopieren',
    data: 'Die Speisekarte anlegen, die Amigo gelesen hat',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: '{{categories}} und {{dishes}} anlegen',
    from: {
      file: 'Aus deiner Datei gelesen',
      chat: 'Aus unserem Chat gelesen',
    },
    summary: 'Legt {{categories}} und {{dishes}} an. Jedes Gericht mit Preis findest du in der Liste darunter.',
    price: 'Preis',
    tax_category: 'Steuerkategorie',
    no_price: 'Noch kein Preis',
    default_tax: 'Dein Standardsatz',
    // Once approved: the import's run, in the words of creating a menu.
    creating: 'Lege {{categories}} und {{dishes}} an…',
    done: 'Die Speisekarte ist angelegt: {{categories}}, {{dishes}} und {{option_groups}} sind auf der Speisekarte von {{restaurant}}',
    done_plain: 'Die Speisekarte ist angelegt',
  },
  waiting: 'Wartet auf Freigabe',
  labels: {
    from: 'Von',
    to: 'Nach',
    menu: 'Speisekarte',
    brings_over: 'Übernimmt',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 Kategorien, 140 Gerichte"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "Die Speisekarte, die Amigo gelesen hat · 2 Kategorien, 4 Gerichte" (B19)
    data: 'Die Speisekarte, die Amigo gelesen hat · {{categories}}, {{dishes}}',
  },
  to: {
    only_location: '{{name}}, einziger Standort',
    brand_one: 'Markenkarte {{name}}, einziger Standort',
    brand_other: 'Markenkarte {{name}}, alle {{count}} Standorte',
  },
  menu: {
    empty: 'Leer, das wird also die Speisekarte',
    adds: 'Kommt zur aktuellen Speisekarte dazu ({{size}}). Gerichte mit gleichem Namen werden aktualisiert, nichts wird entfernt.',
    // The menu's name and size: "Speisekarte: 12 Kategorien, 140 Gerichte".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} Kategorie',
    categories_other: '{{count}} Kategorien',
    dishes_one: '{{count}} Gericht',
    dishes_other: '{{count}} Gerichte',
    option_groups_one: '{{count}} Optionsgruppe',
    option_groups_other: '{{count}} Optionsgruppen',
  },
  // What an import brings over, as one list: "Kategorien, Gerichte, Preise, Optionsgruppen, Fotos und Allergene und
  // Nährwerte, wo Lieferando sie hat". The list's first letter is capitalised.
  brings_over: {
    everything: 'Alles, so wie es ist',
    categories: 'Kategorien',
    dishes: 'Gerichte',
    descriptions: 'Beschreibungen',
    prices: 'Preise',
    option_groups: 'Optionsgruppen',
    photos: 'Fotos',
    where: {
      allergens_nutrition: 'Allergene und Nährwerte, wo {{platform}} sie hat',
      allergens: 'Allergene, wo {{platform}} sie hat',
      nutrition: 'Nährwerte, wo {{platform}} sie hat',
    },
  },
  not_live:
    '{{restaurant}} ist noch nicht live: Gäste sehen die Speisekarte über den Shop-Link, können aber nicht bestellen.',
  buttons: {
    import: 'Importieren',
    copy: 'Kopieren',
    cancel: 'Abbrechen',
  },
  hint: 'Oder antworte unten, um etwas zu ändern.',
  action_failed: 'Das hat nicht geklappt, es wurde nichts geändert. Versuch es gleich noch mal.',
  refused: {
    already_running: 'Dieser Import läuft schon. Amigo sagt dir hier Bescheid, sobald er fertig ist.',
    already_applying: 'Das wird gerade übernommen. Warte einen Moment, bis es fertig ist.',
  },
  importing: {
    title: {
      import: 'Importiere von {{platform}}…',
      copy: 'Kopiere von {{restaurant}}…',
    },
    started: 'Gestartet um {{time}}',
    queued: 'Startet gleich…',
    hint: 'Das kann ein paar Minuten dauern. Du kannst das Panel schließen oder weiterarbeiten; ich melde das Ergebnis hier.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "Der Import von
    // Lieferando ist fertig: 12 Kategorien, 140 Gerichte und 38 Optionsgruppen sind auf der Speisekarte von Pizzeria Lupo".
    title: {
      import:
        'Der Import von {{platform}} ist fertig: {{categories}}, {{dishes}} und {{option_groups}} sind auf der Speisekarte von {{restaurant}}',
      copy: 'Die Kopie ist fertig: {{categories}}, {{dishes}} und {{option_groups}} sind auf der Speisekarte',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: 'Der Import von {{platform}} ist fertig',
      copy: 'Die Kopie ist fertig',
    },
    finished: 'Fertig um {{time}}',
    // The page in the sidebar's words: "Menü → Speisekarte öffnen".
    open: '{{page}} öffnen',
  },
  failed: {
    title: {
      import: 'Import nicht möglich: {{reason}}',
      copy: 'Kopieren nicht möglich: {{reason}}',
    },
    title_plain: {
      import: 'Import nicht möglich',
      copy: 'Kopieren nicht möglich',
    },
    nothing: {
      import: 'Es wurde nichts importiert.',
      copy: 'Es wurde nichts kopiert.',
    },
    what_to_try: 'Das kannst du tun:',
    retry: 'Erneut versuchen',
    reasons: {
      listing_not_found: {
        title: 'Eintrag nicht gefunden',
        text: 'Unter diesem Link gibt es bei {{platform}} kein Restaurant. Es wurde nichts importiert.',
        try: 'Öffne den Link im Browser und prüfe, ob er die Speisekarte des Restaurants zeigt. Schick ihn dann noch mal.',
      },
      listing_not_supported: {
        title: 'Eintrag nicht unterstützt',
        text: 'Das ist eine Ketten-Seite bei {{platform}}, nicht die Speisekarte eines Restaurants, deshalb kann ich sie nicht importieren. Es wurde nichts importiert.',
        try: 'Schick den Link zur Speisekarte des Restaurants bei {{platform}}.',
      },
      platform_failed: {
        title: 'Fehler bei {{platform}}',
        text: '{{platform}} hat nicht geantwortet, deshalb wurde nichts importiert.',
        try: 'Versuch es in ein paar Minuten noch mal.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'Fehler beim Kopieren',
        text: 'Das Kopieren wurde nicht abgeschlossen, deshalb wurde nichts kopiert.',
        try: 'Versuch es in ein paar Minuten noch mal.',
      },
      // {{listing}} and {{currency}} are currencies with their sign as the browser names them ("Britische Pfund (£)",
      // "Euro (€)"), so each stands after "nutzt", where that form is right ("in Britische Pfund" isn't). {{page}} is
      // the sidebar's My info.
      currency_mismatch: {
        title: 'Währung passt nicht',
        text: 'Die Speisekarte nutzt {{listing}}, {{restaurant}} aber {{currency}}. Es wurde nichts importiert.',
        try: 'Schick eine Speisekarte, die {{currency}} nutzt, oder prüf zuerst die Währung des Restaurants unter {{page}}.',
        text_other: 'Die Speisekarte nutzt eine andere Währung als {{restaurant}}. Es wurde nichts importiert.',
        try_other:
          'Schick eine Speisekarte in der Währung des Restaurants oder prüf zuerst seine Währung unter {{page}}.',
      },
      link_paused: {
        title: 'Link pausiert',
        text: 'Dieser Link ist 3-mal hintereinander fehlgeschlagen, deshalb sind Importe davon bis {{time}} pausiert. Es wurde nichts importiert.',
        text_no_until:
          'Dieser Link ist 3-mal hintereinander fehlgeschlagen, deshalb sind Importe davon vorerst pausiert. Es wurde nichts importiert.',
        try: 'Schick einen Link von einer anderen Plattform oder kopier die Speisekarte von einem anderen Restaurant.',
      },
    },
  },
  stopped: {
    title: 'Gestoppt: {{restaurant}} ist live gegangen',
    nothing: {
      import: 'Es wurde nichts importiert',
      copy: 'Es wurde nichts kopiert',
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Abgebrochen',
    expired: 'Abgelaufen',
    replaced: 'Ersetzt',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Freigegeben.',
    cancelled: 'Abgebrochen.',
    retried: 'Erneut versucht.',
  },
};
